<div class="error-page" [attr.data-testid]="pageId">
    <div>
        <h2>Siden findes ikke</h2>
        <p>Siden, du leder efter, findes ikke... desværre.</p>
        <p>
            Gå tilbage til <strong><a [routerLink]="'/'">forsiden</a></strong>
        </p>
    </div>
</div>
